import React, { useState } from "react";
import { View } from 'react-native'
import LoadingComponent from 'components/atoms/Loading'
import ThemedBlock from 'components/atoms/ThemedBlock'
import i18n from 'utils/i18n'
import Button from 'theme/Button'
import _ from 'lodash'
import { StatisticTables } from 'scenes/management/statistics/data/tables'
import { ThemedShared } from 'styles/themed'
import ThemedModal from 'components/atoms/ThemedModal'
import ManagementStatisticsDetailsScene from 'scenes/management/statistics/details'
import { GraphContainerStyles } from 'styles/components/atoms/GraphContainer'
import HelperString from 'utils/helper-string'
import isEqual from 'react-fast-compare'
import HelperDate, { dateFormat } from 'utils/helper-date'
import VStack from 'components/atoms/stack/VStack'

const GraphContainer = ({ children, title, button, chart = {} } = {} ) => {
	
	const [ viewWidth, setViewWidth ] = useState( null );
	const [ modalVisible, setModalVisible ] = useState( false )
	const [ modalData, setModalData ] = useState({ statistics: {}, data: {} })
	
	if( !_.isEmpty( chart ) ) {
		// Set title when not set
		if( !title && !_.isEmpty( chart.name ) ) {
			title = chart.name
		}
	}
	
	const header = [];
	if( title ) {
		const translatedTitle = i18n.t(`management:charts.${title}.title` );
		if( !_.endsWith( translatedTitle, '.title' ) ) {
			header.push( translatedTitle )
		}
		
		let description = '';
		const translatedDescription = i18n.t(`management:charts.${title}.description` );
		if( !_.endsWith( translatedDescription, '.description' ) ) {
			description = translatedDescription
		}
		
		const dateRange = _.get( chart, 'date_range', [] );
		if( _.size( dateRange) === 2 ) {
			const dateRangeFrom = HelperDate.date( dateRange[ 0 ] ).format( dateFormat.DATE_PRETTY )
			const dateRangeTill = HelperDate.date( dateRange[ 1 ] ).format( dateFormat.DATE_PRETTY )
			
			switch( true ) {
				case dateRangeFrom === dateRangeTill:
					description += ' ' + _.toLower( i18n.t('management:generic.today' ) )
					break;
				
				default:
					description += ' ' + _.toLower( i18n.t('management:generic.from_to', {
						from: dateRangeFrom,
						till: dateRangeTill,
					} ) )
			}
		}
		
		if( !_.isEmpty( description ) ) {
			header.push( description )
		}
	}
	
	const nextStatistic = StatisticTables[ title ];
	
	const onPressDetails = () => {
		setModalData({
			statistics: nextStatistic.identifier,
			data: button
		})
		
		setModalVisible( true )
	}
	
	let headerButton = null;
	if( button && !_.isUndefined( nextStatistic ) ) {
		headerButton = (
			<Button
				size={"small"}
				appearance={ "ghost" }
				onPress={ onPressDetails }>
				
				{ i18n.t('management:pages.statistics.index.btn_details') }
			</Button>
		)
	}
	
	return (
		<VStack>
			<ThemedBlock
				key={ HelperString.hash('graph-container-block', title ) }
				header={ header }
				headerButton={ headerButton }
				shadow>
				
				<View
					style={ GraphContainerStyles.container }
					onLayout={(event) => {
						const {x, y, width, height} = event.nativeEvent.layout;
						
						// Only update when different
						if( width !== viewWidth ) {
							setViewWidth( width )
						}
					}}>
					
					<Choose>
						<When condition={ viewWidth === null }>
							<LoadingComponent />
						</When>
						<Otherwise>
							{ React.cloneElement( children, {
								width: viewWidth
							}) }
						</Otherwise>
					</Choose>
				</View>
			</ThemedBlock>
			
			<ThemedModal
				key={ HelperString.hash('graph-container-modal', title) }
				visible={ modalVisible }
				setVisible={ setModalVisible }
				backdropStyle={ ThemedShared.backdrop }>
				
				{/* No render when not visible */}
				{ modalVisible && (
					<ManagementStatisticsDetailsScene
						{ ...modalData }
					/>
				)}
			</ThemedModal>
		</VStack>
	)
}


export default React.memo( GraphContainer, isEqual );
